import { render } from "./UpdateFeaturingPage.vue?vue&type=template&id=4ecd0a3d"
import script from "./UpdateFeaturingPage.vue?vue&type=script&lang=js"
export * from "./UpdateFeaturingPage.vue?vue&type=script&lang=js"

import "./UpdateFeaturingPage.vue?vue&type=style&index=0&id=4ecd0a3d&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__